import {
  LINE_NO_FILTER_KEY,
  REVIEW_FILTER_KEY,
  REVIEW_MEMO_FILTER_KEY,
} from './detailGridTypes'

export interface DetailFilterContext {
  detailRows: Record<string, string>[]
  detailReviewed?: boolean[]
  detailReviewMemos?: (string | null)[]
}

/** 絞込 state から有効な条件のみ抽出（reviewed は大小文字変換しない） */
export function getActiveColumnFilters(
  columnFilters: Record<string, string>,
): ReadonlyArray<readonly [string, string]> {
  return Object.entries(columnFilters)
    .map(([k, v]) => [k, v.trim()] as const)
    .filter(([, v]) => v !== '')
    .map(([k, v]) => [k, k === REVIEW_FILTER_KEY ? v : v.toLowerCase()] as const)
}

export function matchesDetailRowFilter(
  rowIdx: number,
  key: string,
  filterValue: string,
  ctx: DetailFilterContext,
): boolean {
  if (key === LINE_NO_FILTER_KEY) {
    // 画面表示の絶対行号（rowIdx + 1）に対する部分一致
    return String(rowIdx + 1).includes(filterValue)
  }
  if (key === REVIEW_FILTER_KEY) {
    if (filterValue === '') return true
    const reviewed = ctx.detailReviewed?.[rowIdx] ?? false
    if (filterValue === 'true') return reviewed
    if (filterValue === 'false') return !reviewed
    return true
  }
  if (key === REVIEW_MEMO_FILTER_KEY) {
    const memo = (ctx.detailReviewMemos?.[rowIdx] ?? '').toString().toLowerCase()
    return memo.includes(filterValue)
  }
  const cell = (ctx.detailRows[rowIdx]?.[key] ?? '').toString().toLowerCase()
  return cell.includes(filterValue)
}

export function filterDetailRowIndices(
  detailRows: Record<string, string>[],
  columnFilters: Record<string, string>,
  ctx: Omit<DetailFilterContext, 'detailRows'>,
): number[] {
  const activeFilters = getActiveColumnFilters(columnFilters)
  if (activeFilters.length === 0) {
    return detailRows.map((_, i) => i)
  }
  const fullCtx: DetailFilterContext = { detailRows, ...ctx }
  return detailRows.reduce<number[]>((acc, _, idx) => {
    const ok = activeFilters.every(([key, value]) =>
      matchesDetailRowFilter(idx, key, value, fullCtx),
    )
    if (ok) acc.push(idx)
    return acc
  }, [])
}

export function hasActiveColumnFilters(columnFilters: Record<string, string>): boolean {
  return Object.values(columnFilters).some(v => v.trim() !== '')
}
